import HttpClient from '../../core/services/http-client';
import { getAuthData } from '../utils/storage';
import {
    BASE_URI, GET_WAITING_ROOMS_PATH, GET_WAITING_ROOM_PATH, UPSERT_WAITING_ROOM_PATH, DELETE_WAITIM_ROOM_PATH,
    START_WAITING_ROOM_PATH, STOP_WAITING_ROOM_PATH, GET_WAITING_ROOM_SESSION_POSITION_PATH,
    GET_WAITING_ROOM_CHART_PATH, GET_WAITING_ROOM_STATS_PATH, GET_RETURN_INFO_PATH, START_IN_QUEUE_PATH,
    ADD_AGAIN_IN_WAITING_ROOM_PATH,
} from './config';

export const fetchWaitingRooms = async (page = 1, searchTerm = '') => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const params = new URLSearchParams({ page: page.toString() });
        if (searchTerm.trim()) {
            params.append('search', searchTerm.trim());
        }

        const response = await HttpClient.execute(`${BASE_URI}${GET_WAITING_ROOMS_PATH}?${params.toString()}`, 'GET', headers);
        if (!response.ok) {
            throw new Error(response.status === 403 ? 'Unauthorized' : 'Error fetching waiting rooms');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const fetchWaitingRoom = async (id) => {
    try {
        const response = await HttpClient.execute(`${BASE_URI}${GET_WAITING_ROOM_PATH}?waitingRoomId=${id}`, 'GET');
        if (!response.ok) {
            throw new Error('Error fetching waiting room');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const upsertWaitingRoom = async (payload) => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const response = await HttpClient.execute(`${BASE_URI}${UPSERT_WAITING_ROOM_PATH}`, 'POST', headers, JSON.stringify(payload));
        if (!response.ok) {
            throw new Error('Error upserting waiting room');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const deleteWaitingRoom = async (id) => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const response = await HttpClient.execute(`${BASE_URI}${DELETE_WAITIM_ROOM_PATH}?waitingRoomId=${id}`, 'DELETE', headers);
        if (!response.ok) {
            throw new Error('Error deleting waiting room');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const startWaitingRoom = async (id) => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const response = await HttpClient.execute(`${BASE_URI}${START_WAITING_ROOM_PATH}?waitingRoomId=${id}`, 'POST', headers);
        if (!response.ok) {
            throw new Error('Error starting waiting room');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const stopWaitingRoom = async (id) => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const response = await HttpClient.execute(`${BASE_URI}${STOP_WAITING_ROOM_PATH}?waitingRoomId=${id}`, 'POST', headers);
        if (!response.ok) {
            throw new Error('Error stopping waiting room');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const fetchWaitingRoomSessionPosition = async (waitingRoomId, sessionId) => {
    try {
        const response = await HttpClient.execute(`${BASE_URI}${GET_WAITING_ROOM_SESSION_POSITION_PATH}?waitingRoomId=${waitingRoomId}&sessionId=${sessionId}`, 'GET');
        if (!response.ok) {
            throw new Error('Error fetching user position');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const fetchWaitingRoomChart = async (id, startDate, endDate, groupedBy) => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const response = await HttpClient.execute(`${BASE_URI}${GET_WAITING_ROOM_CHART_PATH}?id=${id}&startDate=${startDate}&endDate=${endDate}&groupedBy=${groupedBy}`, 'GET', headers);
        if (!response.ok) {
            throw new Error('Error fetching chart data');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const fetchWaitingRoomStats = async (waitingRoomId) => {
    try {
        const token = getAuthData().access_token;
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        const response = await HttpClient.execute(`${BASE_URI}${GET_WAITING_ROOM_STATS_PATH}?waitingRoomId=${waitingRoomId}`, 'GET', headers);
        if (!response.ok) {
            throw new Error('Error fetching waiting room stats');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const fetchReturnInfo = async (waitingRoomId, sessionId) => {
    try {
        const response = await HttpClient.execute(`${BASE_URI}${GET_RETURN_INFO_PATH}?waitingRoomId=${waitingRoomId}&sessionId=${sessionId}`, 'GET');
        if (!response.ok) {
            throw new Error('Error fetching token');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const verifyToken = async (token, sessionId) => {
    try {
        const response = await HttpClient.execute(`${BASE_URI}${START_IN_QUEUE_PATH}?token=${token}&sessionId=${sessionId}`, 'GET');
        if (!response.ok) {
            throw new Error('Error verifying token');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export const addAgainInWaitingRoom = async (waitingRoomId, oldSessionId, sessionId) => {
    try {
        const response = await HttpClient.execute(`${BASE_URI}${ADD_AGAIN_IN_WAITING_ROOM_PATH}?waitingRoomId=${waitingRoomId}&oldSessionId=${oldSessionId}&sessionId=${sessionId}`, 'GET');
        if (!response.ok) {
            throw new Error('Error adding in waiting room');
        }

        const decodedResponse = await response.json();
        return decodedResponse;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};
